var track = require('@enhancer/fe-error-track');
track('project-center-assets');


// WEBPACK FOOTER //
// ./src/app/app.js